import request from "@/utils/request"

// 配置明细查询
export function paramConfigDetail(query){
  return request({
    url:'/db/param-config/detail',
    method:'get',
    params:query
  })
}

// 配置明细修改
export function update(data){
  return request({
    url:'/db/param-config/update',
    method:'post',
    data
  })
}